import { removeToken } from "./LocalStorage";

export function makeLogout(){
    removeToken();
    // window.location.reload()
}